import { render, staticRenderFns } from "./UnassignedTableList.vue?vue&type=template&id=9742390c&scoped=true"
import script from "./UnassignedTableList.vue?vue&type=script&lang=js"
export * from "./UnassignedTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9742390c",
  null
  
)

export default component.exports